












import { defineComponent, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"

const PreviewImageTypeEnum = Common.PreviewImageTypeEnum;

export default defineComponent({
  props: {
    imageType: {
      type: String as PropType<string>,
      required: true,
    },
    dispImageTypes: {
      type: Array as PropType<number[]>,
      required: true,
    },
    previewImageType: {
      type: Number as PropType<number>,
      required: true,
    },
    title: {
      type: String as PropType<string>,
      required: true,
    },
    changeImageTypeHandler: {
      type: Function as PropType<(imageType: number) => void>,
      required: true,
    },
  },
  setup (props, context) {

    

    return {
      PreviewImageTypeEnum,
    }
  }
});
